<template>
  <!-- Desktop Table Skeleton -->
  <div v-if="type === 'table'" class="hidden xl:block overflow-x-auto">
    <table class="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
      <thead class="bg-gray-50 dark:bg-black">
        <tr>
          <th
            v-for="col in columns"
            :key="col"
            scope="col"
            class="px-3 sm:px-6 py-4 text-center"
          >
            <div class="h-4 bg-gray-300 dark:bg-gray-600 rounded animate-pulse"></div>
          </th>
        </tr>
      </thead>
      <tbody class="bg-white dark:bg-gray-900 divide-y divide-gray-200 dark:divide-gray-700">
        <tr
          v-for="row in rows"
          :key="row"
          class="odd:bg-white even:bg-gray-25 dark:odd:bg-gray-900 dark:even:bg-gray-800"
        >
          <td
            v-for="col in columns"
            :key="col"
            class="px-3 sm:px-6 py-4 whitespace-nowrap text-center"
          >
            <div class="h-4 bg-gray-200 dark:bg-gray-800 rounded animate-pulse"></div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Mobile Card Skeleton -->
  <div v-else-if="type === 'card'" class="xl:hidden divide-y divide-gray-200 dark:divide-gray-700">
    <div
      v-for="row in rows"
      :key="row"
      class="p-4 space-y-3"
    >
      <!-- Header -->
      <div class="flex items-center justify-between">
        <div class="h-5 bg-gray-200 dark:bg-gray-800 rounded w-32 animate-pulse"></div>
        <div class="h-6 bg-gray-200 dark:bg-gray-800 rounded w-20 animate-pulse"></div>
      </div>

      <!-- Email -->
      <div class="space-y-1">
        <div class="h-4 bg-gray-200 dark:bg-gray-800 rounded w-16 animate-pulse"></div>
        <div class="h-4 bg-gray-200 dark:bg-gray-800 rounded w-48 animate-pulse"></div>
      </div>

      <!-- Vehicles & Tires -->
      <div class="grid grid-cols-2 gap-3">
        <div class="space-y-1">
          <div class="h-4 bg-gray-200 dark:bg-gray-800 rounded w-16 animate-pulse"></div>
          <div class="h-4 bg-gray-200 dark:bg-gray-800 rounded w-8 animate-pulse"></div>
        </div>
        <div class="space-y-1">
          <div class="h-4 bg-gray-200 dark:bg-gray-800 rounded w-12 animate-pulse"></div>
          <div class="h-4 bg-gray-200 dark:bg-gray-800 rounded w-8 animate-pulse"></div>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="flex gap-2 pt-3 border-t border-gray-100 dark:border-gray-700">
        <div class="flex-1 h-9 bg-gray-200 dark:bg-gray-800 rounded animate-pulse"></div>
        <div class="flex-1 h-9 bg-gray-200 dark:bg-gray-800 rounded animate-pulse"></div>
        <div class="flex-1 h-9 bg-gray-200 dark:bg-gray-800 rounded animate-pulse"></div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  type: 'table' | 'card';
  rows?: number;
  columns?: number;
}>();
</script>

<style scoped>
.bg-gray-25 {
  background-color: rgb(249, 250, 251);
}
</style>

